import z from 'zod'

export enum ApplicationAccountStatus {
  PENDING = 'PENDING',
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}

export const applicationAccountModel = z.object({
  __typename: z.literal('ApplicationAccount').default('ApplicationAccount'),
  id: z.string(),
  accountId: z.string(),
  applicationId: z.string(),
  accountFields: z.record(z.string()).nullable(),
  tag: z.array(z.string()),
  accountKey: z.string(),
  externalId: z.string().nullable(),
  isMainAccount: z.boolean(),
  status: z.nativeEnum(ApplicationAccountStatus),
  metadata: z.record(z.string()).nullable(),
  isActive: z.boolean(),
})

export type ApplicationAccountModel = z.infer<typeof applicationAccountModel>
